/**
 * Detects if the current device is running iOS (iPhone, iPad, iPod)
 * Uses multiple detection methods for reliability
 */
export const isIOSDevice = (): boolean => {
  // Check if we're in a browser environment
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  // Method 1: Check for iOS-specific touch events and properties
  const hasIOSTouchEvents = "ontouchstart" in window && navigator.maxTouchPoints > 0;

  // Method 2: User agent detection for iOS devices
  const userAgent = navigator.userAgent || "";
  const isIOSUserAgent = /iPhone|iPad|iPod/i.test(userAgent);

  // Method 3: Check for iOS Safari specific behavior
  const isIOSSafari =
    /Safari/i.test(userAgent) && !/Chrome|CriOS|FxiOS/i.test(userAgent) && hasIOSTouchEvents;

  // Method 4: Check platform (more reliable on newer iOS versions)
  const platform = navigator.platform || "";
  const isIOSPlatform = /iPhone|iPad|iPod/i.test(platform);

  // Method 5: Check for iOS specific standalone mode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isInStandaloneMode = "standalone" in navigator && (navigator as any).standalone === true;

  // Return true if any iOS indicator is found
  return (
    isIOSUserAgent || isIOSPlatform || (isIOSSafari && hasIOSTouchEvents) || isInStandaloneMode
  );
};

/**
 * Detects if the current viewport is mobile-sized (narrow)
 * This is useful for responsive design independent of device type
 */
export const isMobileViewport = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.innerWidth <= 768;
};
